var components = {}

var requireComponentGlobal = require.context('./', false, /[A-Z]\w+\.(vue|js)$/)

requireComponentGlobal.keys().forEach(function(filename) {

	var componentFilename = filename.replace(/\//g, '').replace('.vue', '').replace('.', '')
	var componentName = filename.replace(/\//g, '').replace('.vue', '').replace('.', '').toLowerCase()

	components[componentName] = () => import('./' + componentFilename)

})

export default components